import React from 'react';
import { Carousel } from './Carousel';
import {
  talenox,
  sage,
  quickbooks,
  xero,
  wave,
  freeagent,
  zoho,
  vend,
  unleashed,
  shopify,
  googleAnalytics,
  googleWorkspace,
  facebook,
  mailchimp,
  linkedin,
  instagram,
} from './logos';

function Infographic({ name }) {
  return (
    <img
      alt=""
      src={`../images/vm/m-track/${name}-infographic@1x.png`}
      srcSet={`../images/vm/m-track/${name}-infographic@1x.png 1x, ../images/vm/m-track/${name}-infographic@2x.png 2x`}
    />
  );
}

function LogoList({ items }) {
  return (
    <ul className="mt-logo-list">
      {items.map(([displayName, name]) => (
        <li key={`mt-${name}-logo-item`}>
          <img
            alt={displayName}
            src={`../images/vm/m-track/logos/${name}-logo@1x.png`}
            srcSet={`../images/vm/m-track/logos/${name}-logo@1x.png 1x, ../images/vm/m-track/logos/${name}-logo@2x.png 2x`}
          />
        </li>
      ))}
    </ul>
  );
}

function KeyAreaItem({ children, logos, name }) {
  return (
    <div className="mt-row">
      <div className="mt-column">
        {children}
        <LogoList items={logos} />
      </div>
      <div className="mt-column mt-column--infographic">
        <Infographic name={name} />
      </div>
    </div>
  );
}

export function KeyAreasCarousel() {
  return (
    <div className="mt-content-carousel">
      <Carousel
        dots={true}
        infinite={false}
        pauseOnHover={true}
        id="btContentCarousel"
      >
        <KeyAreaItem
          name="accounting"
          logos={[sage, quickbooks, xero, wave, freeagent, zoho]}
        >
          <h2>Accounting and finance tools</h2>
          <p className="mt-strapline">
            Connect your accounting software to our dashboard to help you chase
            outstanding debts, see your current cashflow and manage other
            financial data alongside your account data in real-time. Stay in
            control of your business.
          </p>
        </KeyAreaItem>
        <KeyAreaItem name="hr" logos={[talenox]}>
          <h2>HR &amp; Payroll</h2>
          <p className="mt-strapline">
            See your important people data alongside finance and other business
            stats to help you manage leave requests, absences and your other
            people resources. Never make a people based decision without more
            information to hand.
          </p>
        </KeyAreaItem>
        <KeyAreaItem name="sales" logos={[vend, unleashed, shopify]}>
          <h2>Sales and inventory</h2>
          <p className="mt-strapline">
            Using your ecommerce connection, see your product and stock
            information alongside the stats relating to your websites
            performance and marketing channels. Helping you to make sure your
            marketing efforts are delivering.
          </p>
        </KeyAreaItem>
        <KeyAreaItem
          name="social"
          logos={[googleAnalytics, facebook, mailchimp, linkedin, instagram]}
        >
          <h2>Social media and marketing analytics</h2>
          <p className="mt-strapline">
            Track how your campaigns are performing and the traffic going to
            your website alongside your key financial and ecommerce data. Have
            confidence in your marketing spend as you track it alongside
            available funds and product stock.
          </p>
        </KeyAreaItem>
        <KeyAreaItem name="productivity" logos={[googleWorkspace]}>
          <h2>Productivity</h2>
          <p className="mt-strapline">
            Boost the efficiency of your business by having all your documents
            and important information in one handy place. Combine emails,
            communication apps, video conferencing, file sharing, calendars and
            more. You'll have everything covered.
          </p>
        </KeyAreaItem>
      </Carousel>
    </div>
  );
}
